(function () {
  if (window.__steryeHorrorPreorderInitialized) return;
  window.__steryeHorrorPreorderInitialized = true;

  const productRoot = document.querySelector('[data-horror-preorder-root]');
  if (!productRoot) return;

  const TIER_INFO = {
    small: { title: 'The Small Box', price: '$40.50' },
    tshirt: { title: 'The T-Shirt Box', price: '$53.10' },
    large: { title: 'The Large Box', price: '$67.50' },
    ultimate: { title: 'The Ultimate Box', price: '$102.60' }
  };

  const normalizeTier = (text) => {
    const value = String(text || '').toLowerCase().replace(/[-_]/g, ' ');
    if (value.includes('t shirt') || value.includes('tee') || value.includes('shirt')) return 'tshirt';
    if (value.includes('ultimate')) return 'ultimate';
    if (value.includes('large')) return 'large';
    return 'small';
  };

  const tierInputs = () => Array.from(
    document.querySelectorAll('.horror-box-variant-cards input[type="radio"]')
  );

  const getCheckedTierInput = () =>
    document.querySelector('.horror-box-variant-cards input[type="radio"]:checked');

  const getCurrentTier = () => {
    const selected = getCheckedTierInput();
    return normalizeTier(selected && (selected.dataset.horrorTier || selected.value));
  };

  const sticky = document.querySelector('[data-horror-sticky]');
  const stickyTier = document.querySelector('[data-horror-sticky-tier]');
  const stickyPrice = document.querySelector('[data-horror-sticky-price]');
  const stickyButton = document.querySelector('[data-horror-sticky-button]');
  const productForm = document.querySelector('.product__info-container form[action*="/cart/add"]') ||
    document.querySelector('form[action*="/cart/add"]');

  // Remove only duplicate helper UI. This does not touch Shopify's native product options/forms.
  document.querySelectorAll('[data-horror-sticky]').forEach((bar, index) => {
    if (index > 0) bar.remove();
  });
  document.querySelectorAll('.horror-preorder-shirt-field').forEach((field) => field.remove());

  const quickPanels = Array.from(document.querySelectorAll('.product__info-container .horror-preorder-quick'));
  quickPanels.forEach((panel, index) => {
    if (index > 0) panel.remove();
  });

  const setSubmitCopy = () => {
    document.querySelectorAll('.product__info-container .product-form__buttons .product-form__submit').forEach((button) => {
      if (button.disabled || button.getAttribute('aria-disabled') === 'true') return;
      const span = button.querySelector('span') || button;
      if (span.textContent.trim() !== 'PREORDER YOUR BOX') span.textContent = 'PREORDER YOUR BOX';
    });
  };

  const updateSticky = (tier) => {
    const info = TIER_INFO[tier] || TIER_INFO.small;
    if (stickyTier) stickyTier.textContent = info.title;
    if (stickyPrice) stickyPrice.textContent = info.price;
  };

  const update = () => {
    const tier = getCurrentTier();
    updateSticky(tier);
    setSubmitCopy();
  };

  const selectTier = (tier) => {
    const input = tierInputs().find((candidate) =>
      normalizeTier(candidate.dataset.horrorTier || candidate.value) === tier &&
      !candidate.classList.contains('disabled') &&
      !candidate.disabled
    );

    if (!input) return;
    input.click();
    input.focus({ preventScroll: true });
    update();

    const target = document.querySelector('variant-selects') || productRoot;
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
  };

  document.addEventListener('change', (event) => {
    if (event.target.matches('.horror-box-variant-cards input[type="radio"]')) {
      window.requestAnimationFrame(update);
    }
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-horror-select-tier]');
    if (!button) return;
    event.preventDefault();
    selectTier(normalizeTier(button.dataset.horrorSelectTier));
  });

  if (stickyButton) {
    stickyButton.addEventListener('click', (event) => {
      event.preventDefault();
      const variantPicker = document.querySelector('.horror-box-variant-cards') ||
        document.querySelector('variant-radios') ||
        document.querySelector('variant-selects') ||
        document.querySelector('.product-form__input');
      if (!variantPicker) return;

      const header = document.querySelector('.shopify-section-header-sticky') ||
        document.querySelector('sticky-header') ||
        document.querySelector('header');
      const headerOffset = header ? header.getBoundingClientRect().height : 0;
      const top = variantPicker.getBoundingClientRect().top + window.pageYOffset - headerOffset - 16;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    });
  }

  if (sticky && productForm && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      sticky.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { threshold: 0 });
    observer.observe(productForm);
  }

  // Dawn can replace the button/variant markup after a variant changes; re-apply after those updates.
  document.addEventListener('variant:change', () => window.requestAnimationFrame(update));
  document.addEventListener('shopify:section:load', () => window.requestAnimationFrame(update));
  update();
})();
